import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const SevenroomsIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="M16 6a10 10 0 0 1 9.235 6.162c.208.417.36.865.45 1.336.206.8.315 1.638.315 2.502 0 5.523-4.477 10-10 10S6 21.523 6 16 10.477 6 16 6ZM8.38 20.79a8.993 8.993 0 0 0 7.12 4.195v-9.767h.007a5.19 5.19 0 0 1-.049-.491l-.007-.266c0-.25.019-.495.053-.734L8.38 20.79Zm8.12 4.195a8.958 8.958 0 0 0 5.344-2.143l-4.385-4.296a5.195 5.195 0 0 1-.959-.967v7.406Zm8.4-7.653a5.155 5.155 0 0 1-4.287 2.291l-.265-.007a5.169 5.169 0 0 1-.407-.038l2.626 2.572a8.967 8.967 0 0 0 2.333-4.818ZM9.04 10.294A8.963 8.963 0 0 0 7 16c0 1.39.315 2.705.877 3.88l8.661-8.588a5.193 5.193 0 0 1 1.03-.998H9.04Zm11.573.005a4.156 4.156 0 0 0-3.317 1.647l.002.002-.009.008a4.144 4.144 0 0 0-.838 2.505c0 1.352.646 2.552 1.645 3.312h.002l.017.016a4.163 4.163 0 0 0 6.593-4.068 8.925 8.925 0 0 0-.385-1.147 4.161 4.161 0 0 0-3.71-2.275ZM16 7a8.965 8.965 0 0 0-6.001 2.294h10.804v.009l.076.003c.5.025.98.122 1.431.279A8.97 8.97 0 0 0 16 7Z"
      fill={preserveColor ? '#1D1D1D' : undefined}
    />
  </BaseIcon>
);
